export default "__VITE_ASSET__BG2DpQhs__"